const ConnectButton: React.FC = () => null;

export default ConnectButton;
